import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { default as AppStringsDa } from '../../../assets/resources/appstrings.da.json';
import { default as AppStringsEn } from '../../../assets/resources/appstrings.en.json';

@Pipe({
  name: 'appString',
  pure: true,
})
@Injectable({
  providedIn: 'root',
})

export class AppStringsPipe implements PipeTransform {
  private appStringsDa: object;
  private appStringsEn: object;

  constructor() {
    this.appStringsDa = AppStringsDa;
    this.appStringsEn = AppStringsEn;
  }

  transform(value: string, locale: string = 'da'): string {
    return this.get(value, locale);
  }

  private get(lookup: string, locale: string): string {
    if (lookup == null) {
      throw new Error(`AppStrings: Lookup is null: ${lookup}`);
    }

    const keys = lookup.split('.');
    if (keys.length === 0) {
      throw new Error(`AppStrings: Lookup is empty: ${lookup}`);
    }
    let returnValue = '';
    let node: object;

    if (locale == 'da') {
      node = this.appStringsDa;
    } else if (locale == 'en'){
      node = this.appStringsEn;
    } else {
      throw new Error(`AppStrings: Locale not supported: ${locale}`);
    }

    for (let pathpart = 0; pathpart < keys.length; pathpart++) {
      if (node.hasOwnProperty(keys[pathpart]!)) {
        node = node[keys[pathpart]! as keyof object] as object;
      }
      else {
        throw new Error(`AppStrings: Not found: ${pathpart}`);
      }
    }

    if (typeof node === 'string') {
      returnValue = node;
      return returnValue
    }
    throw new Error(`AppStrings: Unable to find string: ${node}`);
  }
}
